import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useSearchUsersForGift = (query, shouldFetch = true) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = deleteEmptyObjects({ query });
		const res = await instance.get("users/search-for-gift", { params });
		return res.data;
	};

	return useQuery(["users-search-for-gift", query], () => fetch(), {
		...fetchConfig,
		enabled: shouldFetch && Boolean(query) && query.length > 0,
	});
};

export default useSearchUsersForGift;
